const getSimpleDateStringFromIsoString = (isoString) => {
  return isoString.split('T')[0];
};

const formatDate = (date) => {
  return getSimpleDateStringFromIsoString(date.toISOString());
};

const dateToHumanReadableDayString = (date, languageCode) => {
  const options = { weekday: 'long', day: 'numeric', month: 'long' };
  const formatted = date.toLocaleDateString(languageCode, options);
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};

const dateToHumanReadableTimeString = (date, languageCode) => {
  const options = { hour: '2-digit', minute: '2-digit', hour12: false };
  return date.toLocaleTimeString(languageCode, options);
};

function isoStringToLocalizedString(isoDateString, languageCode) {
  const date = new Date(isoDateString);

  const dateFormatter = new Intl.DateTimeFormat(languageCode, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  const timeFormatter = new Intl.DateTimeFormat(languageCode, {
    hour: '2-digit',
    minute: '2-digit',
  });

  let formattedDate = dateFormatter.format(date);
  const formattedTime = timeFormatter.format(date);

  formattedDate = formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);

  return `${formattedDate} — ${formattedTime}`;
}

const addDays = (date, days) => {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

const subtractDays = (date, days) => {
  var result = new Date(date);
  result.setDate(result.getDate() - days);
  return result;
};

const dateToTime = (date) => {
  let hours = date.getHours();
  let minutes = date.getMinutes();

  if (hours < 10) {
    hours = '0' + hours;
  }
  if (minutes < 10) {
    minutes = '0' + minutes;
  }

  return `${hours}:${minutes}`;
};

const capitalize = (text) => {
  return text[0].toUpperCase() + text.slice(1);
};

const fetchAgendaData = (url, shop, fromDate, untilDate, productId) => {
  const currentDate = new Date();

  const currentDateFormatted = formatDate(currentDate);
  const fromDateFormatted = formatDate(fromDate);
  const untilDateFormatted = formatDate(untilDate);

  const params = new URLSearchParams({
    shop: shop,
    productId: productId,
    startDate: fromDateFormatted,
    endDate: untilDateFormatted,
    currentDate: currentDateFormatted,
  }).toString();

  const requestUrl = `${url}/schedule?${params}`;

  return fetch(requestUrl);
};
